import { Injectable } from '@angular/core';
import { VehicleTypesState, VehicleTypesStore } from './vehicle-types.store';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { JsonApiEntityService } from '../jsonentity/json-api-entity.service';
import { RelationConfigService } from '../relation-config';
import { VehicleTypesQuery } from './vehicle-types.query';
import { ApiService } from '../../services/api/api.service';

@Injectable({ providedIn: 'root' })
export class VehicleTypesService extends RelationConfigService<VehicleTypesState> {
  protected filterType = 'VEHICLE';

  constructor(
    private store: VehicleTypesStore,
    private query: VehicleTypesQuery,
    private service: ApiService,
  ) {
    super(store, query, service);
  }
}
